import { Mail, MapPin, Building2 } from "lucide-react";
import Seo from "@/components/Seo";
import CalEmbed from "@/components/CalEmbed";

export default function Contact() {
    return (
        <div data-testid="page-contact">
            <Seo
                title="Book a Consultation | Chief AI Partners"
                description="Book a 15-minute conversation with Chief AI Partners. We'll identify whether AI can create practical value in your business."
                path="/contact"
            />

            <section className="cap-section pt-24 md:pt-32 pb-16" data-testid="contact-hero">
                <div className="cap-container grid grid-cols-1 lg:grid-cols-12 gap-10">
                    <div className="lg:col-span-8">
                        <div className="cap-eyebrow mb-6">Contact</div>
                        <h1 className="font-serif text-navy text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight">
                            Book a 15-minute conversation.
                        </h1>
                    </div>
                    <div className="lg:col-span-4 lg:pt-4 space-y-5">
                        <p className="text-slate text-lg leading-relaxed">
                            Let's identify whether AI can create practical value in your business.
                        </p>
                        <p className="text-slate leading-relaxed">
                            This short consultation is designed to understand where your business is today, what is slowing your team down and whether a structured AI rollout makes sense.
                        </p>
                    </div>
                </div>
                <div className="cap-container mt-12"><div className="cap-rule" /></div>
            </section>

            <section className="pb-16 md:pb-24" data-testid="contact-main">
                <div className="cap-container grid grid-cols-1 lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-8">
                        <CalEmbed />
                    </div>

                    <aside className="lg:col-span-4 space-y-10" data-testid="contact-aside">
                        <div>
                            <div className="cap-eyebrow mb-4">Direct contact</div>
                            <ul className="space-y-5">
                                <li className="flex items-start gap-4">
                                    <Building2 className="mt-1 text-navy" size={18} strokeWidth={1.5} />
                                    <div>
                                        <div className="font-serif text-navy text-xl leading-tight">Chief AI Partners</div>
                                    </div>
                                </li>
                                <li className="flex items-start gap-4">
                                    <MapPin className="mt-1 text-navy" size={18} strokeWidth={1.5} />
                                    <div className="text-slate text-base">Sydney, Australia</div>
                                </li>
                                <li className="flex items-start gap-4">
                                    <Mail className="mt-1 text-navy" size={18} strokeWidth={1.5} />
                                    <a
                                        href="mailto:enquiries@chiefai.partners"
                                        className="text-navy border-b border-navy hover:text-teal hover:border-teal transition-colors"
                                        data-testid="contact-email-link"
                                    >
                                        enquiries@chiefai.partners
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div className="border-t border-sand pt-8">
                            <div className="cap-eyebrow mb-3">Privacy note</div>
                            <p className="text-slate text-sm leading-relaxed">
                                By submitting this form, you agree that Chief AI Partners may contact you about your enquiry. See our{" "}
                                <a href="/privacy" className="underline hover:text-navy">Privacy Policy</a> for details.
                            </p>
                        </div>
                    </aside>
                </div>
            </section>
        </div>
    );
}
